import { forwardRef } from "react";

import Icon from "@/components/Icon";
import LunaPeekingSideRight from "./LunaPeekingSideRight.svg.jsx";
import LunaPeekingSideLeft from "./LunaPeekingSideLeft.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LunaPeekingSideIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent"> & { right?: boolean }
>(({ right, ...rest }, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={right ? LunaPeekingSideRight : LunaPeekingSideLeft}
      {...rest}
    />
  );
});

export default LunaPeekingSideIcon;
